import { useTranslations } from "next-intl";

import useSubscriptions from "~/hooks/use-subscriptions";
import loyaltyUtils from "~/utils/loyalty-utils";

import styles from "./loyalty-progress.module.scss";

export default function LoyaltyProgress() {
  const t = useTranslations();
  const { userSubscriptions } = useSubscriptions();

  const loyaltySubscription = loyaltyUtils.getLoyaltySubscription(userSubscriptions);

  return (
    <div className={styles.progressBarWrapper}>
      <div className={styles.pointsWrapper}>
        <p className={styles.pointsNumber}>
          {t.rich("generic.loyaltyPTS", {
            points: loyaltySubscription?.Subscription?.LoyaltyBalance?.Points ?? "0",
            unitText: (chunks) => <span className={styles.pointsUnitText}>{chunks}</span>,
          })}
        </p>
      </div>
    </div>
  );
}
